import { __, Alert, confirm } from 'modules/theme';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import APIManager from 'modules/common/apiManager';
import {
  ModalTrigger,
  Pagination,
  ButtonCommonTheme,
  FormControl,
  Table,
  Label,
  DataWithLoader,
  FormGroup,
  ControlLabel
} from 'modules/theme';
import {
  ModalFooter,
  FormWrapper,
  FormColumn,
  ColumnTitle,
  InfoWrapper
} from 'modules/theme';

class AccountAddEdit extends Component {
  constructor(props) {
    super(props);
    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);

    this.mAPI = new APIManager();
    if (this.props.editData) {
      this.state = {
        name: this.props.editData.name
      };
    } else {
      this.state = {
        name: ''
      };
    }
  }
  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  resetAllData() {
    this.setState({
      name: ''
    });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      // Alert.success(`${data.message}`);
      let message = data && data.message ? data.message :  "Successfully Done";
      Alert.success(message);
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      // Alert.error(`${data.message}`);
      let message = data && data.message ? data.message :  "Something wrong happened";
      Alert.error(message);
    }
  }

  saveData(e) {
    let _this = this;
    e.preventDefault();
    let tData = {
      name: "512dbfb5-ef7e-4212-84cd-0b41bb746424"
    };

    this.mAPI.sendPostAPI(
      `tenant/intialize`,
      tData,
      data => {
        if (data && data.message) {
          Alert.success(`${data.message}`);
        } else {
          Alert.success(`Successfully Added`);
        }
        this.props.update();
        this.resetAllData();
        this.props.closeModal(true);
      },
      (errorCode, data) => {
        this.apiResponse(errorCode, data);
      }
    );
  }


  render() {
    const { modalType } = this.props;
    return (
      <form onSubmit={e => this.saveData(e)}>
        <FormWrapper>
          {/* <FormColumn></FormColumn> */}
          <FormColumn>
            {this.renderFormGroup('Name', {
              defaultValue: '',
              placeholder: 'Name',
              autoFocus: true,
              required: true,
              id: 'name',
              maxLength: 25,
              value: this.state.name,
              onChange: e => {
                if (e.target.value === ' ') {
                  return false;
                }
                this.setState({ name: e.target.value });
              }
            })}
          </FormColumn>
        </FormWrapper>
        <ModalFooter modalType={modalType}>
          <ButtonCommonTheme
            type='greyModalBtn'
            OnClick={() => this.props.closeModal()}
            size="xl"
          >
            Cancel
          </ButtonCommonTheme>
          <ButtonCommonTheme
            type="blueModalBtn"
            size="xl"
            style={{ float: 'right' }}
          >
            {this.props.editData && this.props.editData._id ? 'Update' : 'Generate'}
          </ButtonCommonTheme>
        </ModalFooter>
      </form>

    );
  }
}

export default AccountAddEdit;


// WEBPACK FOOTER //
// src/modules/screens/settings/Account/components/AccountAddEdit.js